import ControlFactory from '@/Factories/ControlFactory';
import NavigationService from '@/Management/NavigationService';
import ComponentManager from '@/Management/ComponentManager';
import LocatorHelper from '@/Utility/LocatorHelper';
import FactorySelectorBoxViewModel from '@/ViewModels/Controls/FactorySelectorBoxViewModel';
import FactorySelectorBox from '@/Controls/FactorySelectorBox';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';

export default class FactorySelectorBoxFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private FactorySelectorBoxViewModel = ComponentManager.getViewModel<typeof FactorySelectorBoxViewModel>('FactorySelectorBoxViewModel');
    private FactorySelectorBox = ComponentManager.getControl<typeof FactorySelectorBox>('FactorySelectorBox');

    /**
     * @override
     */
    public viewModel: FactorySelectorBoxViewModel;

    public constructor(params: any) {
        super(params);
    }
    
    /**
     * @override
     */
    control: FactorySelectorBox;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.FactorySelectorBoxViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            tooltip: this.detailViewItem.tooltip,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            locator: LocatorHelper.buildLocator(this.locator, this.detailViewItem.name)
        });

        this.control = new this.FactorySelectorBox(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    public getValueForFilter(): Object {
        let ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);

        return ret;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name + '.Value',
            value: this.viewModel?.value() || ''
        }
    }
}

ComponentManager.setFactory('FactorySelectorBox', FactorySelectorBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');